// Textes du tableau de bord
export const DASHBOARD_TEXTS = {
  title: 'Tableau de bord',
  refresh: 'Actualiser',
  lastUpdated: 'Dernière mise à jour :',
  selectOrganization: 'Sélectionner une organisation',
  selectOrganizationMessage: 'Veuillez sélectionner une organisation dans la liste déroulante ci-dessus pour voir le tableau de bord.',
  loading: 'Chargement du tableau de bord...',
  
  // Textes de la carte d'emplacement
  locationCard: {
    monitoringOn: 'Surveillance ACTIVÉE',
    monitoringOff: 'Surveillance DÉSACTIVÉE',
    locationOffline: 'Emplacement hors ligne',
    viewDetails: 'Voir les détails',
    noActiveAlerts: 'Aucune alerte active',
    noActiveEvents: 'Aucun événement actif',
    sensor: 'Capteur',
    sensors: 'Capteurs',
    triggered: 'Déclenchée',
    pending: 'En attente',
    triggeredAlert: 'Alerte déclenchée',
    triggeredAlerts: 'Alertes déclenchées',
    pendingAlert: 'Alerte en attente',
    pendingAlerts: 'Alertes en attente',
    offline: 'hors ligne'
  },

  // Textes de la grille d'emplacements
  locationGrid: {
    noLocationsFound: 'Aucun emplacement trouvé',
    noLocationsAdminMessage: 'Aucun emplacement ne correspond à vos critères de recherche. Essayez d\'ajuster vos filtres ou d\'ajouter un nouvel emplacement.',
    noLocationsUserMessage: 'Aucun emplacement trouvé pour votre organisation.'
  },

  // Textes des métriques du tableau de bord
  metrics: {
    locations: 'Emplacements',
    sensors: 'Capteurs',
    triggered: 'Alertes déclenchées',
    pending: 'Alertes en attente',
    offline: 'Emplacements hors ligne'
  },

  // Recherche et filtres
  searchPlaceholder: 'Rechercher des emplacements par nom ou ville...',

  // Textes de pagination
  pagination: {
    page: 'Page',
    of: 'sur'
  },

  // Textes du tableau de bord d'emplacement
  locationDashboard: {
    title: 'Tableau de bord d\'emplacement',
    loadingLocation: 'Chargement de l\'emplacement...',
    loadingSensors: 'Chargement des capteurs...',
    failedToLoadLocation: 'Échec du chargement de l\'emplacement',
    failedToLoadSensors: 'Échec du chargement des capteurs',
    locationNotFound: 'Emplacement non trouvé',
    back: 'Retour',
    refresh: 'Actualiser',
    lastUpdated: 'Dernière mise à jour :',
    monitoringOn: 'Surveillance ACTIVÉE',
    monitoringOff: 'Surveillance DÉSACTIVÉE',
    metrics: {
      totalSensors: 'Total des capteurs',
      locationStatus: 'Statut de l\'emplacement',
      onlineSensors: 'Capteurs en ligne',
      offlineSensors: 'Capteurs hors ligne',
      triggeredAlerts: 'Alertes déclenchées',
      pendingAlerts: 'Alertes en attente'
    },
    sensorsSection: {
      noSensors: 'Aucun capteur trouvé pour cet emplacement.',
      filter: {
        all: 'Tous',
        triggered: 'Déclenchées',
        pending: 'En attente',
        offline: 'Hors ligne'
      }
    }
  }
} as const;